import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { updateManifestLink } from 'utils/dynamicManifest';

/**
 * Wrapper component that enables dynamic manifest updates
 * Must be used inside Router context to access useLocation
 */
const DynamicManifestWrapper: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Update manifest when route changes
    // Use current pathname as fallback if location is undefined
    const currentPath = location?.pathname || window.location.pathname;
    updateManifestLink(currentPath);
  }, [location?.pathname]);

  return null;
};

export default DynamicManifestWrapper;
